import { BRAND } from "@/lib/site";

const WhatsAppIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
    <path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.95 1.17-.17.2-.35.22-.65.07-.3-.15-1.13-.42-2.15-1.33-.8-.71-1.33-1.59-1.48-1.89-.15-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.18.2-.3.3-.5.1-.2.05-.38-.02-.53-.08-.15-.68-1.62-.93-2.21-.24-.58-.48-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.01-1.04 2.45 0 1.44 1.06 2.84 1.21 3.04.15.2 2.09 3.19 5.06 4.36 2.47.97 2.97.78 3.51.73.54-.05 1.74-.71 1.98-1.4.25-.69.25-1.28.18-1.4-.08-.13-.28-.2-.58-.35Z" />
    <path d="M12.04 2C6.6 2 2.18 6.42 2.18 11.86c0 1.74.46 3.44 1.32 4.94L2 22l5.35-1.4a9.82 9.82 0 0 0 4.69 1.2h.01c5.43 0 9.85-4.42 9.85-9.86C21.9 6.42 17.47 2 12.04 2Zm0 17.93h-.01a8.15 8.15 0 0 1-4.15-1.14l-.3-.18-3.09.81.83-3.02-.19-.31a8.1 8.1 0 0 1-1.24-4.31c0-4.52 3.68-8.2 8.2-8.2 2.19 0 4.25.86 5.8 2.4a8.15 8.15 0 0 1 2.4 5.8c0 4.52-3.68 8.2-8.25 8.2Z" />
  </svg>
);

export const WhatsAppFab = () => (
  <a
    href={`https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent("Hello Starke United, I would like an export enquiry for tiles.")}`}
    target="_blank" rel="noopener noreferrer"
    data-testid="whatsapp-fab"
    aria-label={`Chat with ${BRAND.short} on WhatsApp`}
    className="group fixed bottom-6 right-6 z-40 flex items-center gap-2.5 rounded-full bg-[#25D366] px-4 py-3.5 text-sm font-semibold text-white shadow-[0_16px_40px_-12px_rgba(37,211,102,.7)] transition-transform duration-300 hover:-translate-y-1"
  >
    <span className="relative flex h-5 w-5 items-center justify-center">
      <span className="absolute inset-0 animate-ping rounded-full bg-white/40 opacity-70 group-hover:opacity-100" />
      <WhatsAppIcon size={20} />
    </span>
    <span className="hidden sm:inline">Chat on WhatsApp</span>
  </a>
);
